import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  fetchPlanDetails,
  ctlFetchPlanDetails,
  getPlanDetailsCTL,
} from "../../../../shared/hooks/useFetchServiceDetails";
import API_URLS from "../../Utils/axr";
import {EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";
import { v4 as uuidv4 } from "uuid";
import { fixWIFICountWithGrandfather, getServiceAddressId } from "../../Utils/utils";
import DwLogutil from "../../Utils/DwLogutil";
import { setIsUserOnJeopardy } from "./user";

type planDetailsInitialStateType = {
  planDetails: any;
  loading: boolean;
  error: any;
  changePlanUrl: string;
  networkType: any;
  ctlPlanDetails: any;
  ctlLoading: boolean;
  ctlError: any;
  paperLessBilling: boolean;
  isAutoPayEnrolled: boolean;
  isChangeFlow: boolean;
  fetched: boolean;  // subscription-plan API fetched flag
  ctlFetched: boolean;  // subscription-acm API fetched flag
  retryCount: number;  // Track number of subscription-plan API attempts
  ctlRetryCount: number;  // Track number of subscription-acm API attempts
};
const initialState: planDetailsInitialStateType = {
  planDetails: null,
  loading: false,
  error: null,
  changePlanUrl: "",
  networkType: null,
  ctlPlanDetails: null,
  ctlLoading: false,
  ctlError: null,
  paperLessBilling: false,
  isAutoPayEnrolled: false,
  isChangeFlow: false,
  fetched: false,  // subscription-plan API fetched flag
  ctlFetched: false,  // subscription-acm API fetched flag
  retryCount: 0,  // Track number of subscription-plan API attempts
  ctlRetryCount: 0,  // Track number of subscription-acm API attempts
};

export const getPlanDetails = createAsyncThunk(
  "plan/details",
  async (billingAccountNumber: string) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const serviceAddrId = getServiceAddressId(reduxStore?.user?.data?.addresses);
      // const params = {
      //   [API_URLS?.planDetails_QA_Url]: billingAccountNumber,
      // };
      // let data = isChangeFlow && {flow: "change"}
      let flowData = reduxStore?.planDetails?.isChangeFlow

      const payload = {
        baseline: {
          //  transactionId: "09d5bd1a-3c6e-47ba-8a71-9ca83be5f3dc",
          // transactionId: uuidv4().slice(0, 21),
          transactionId:reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
          partnerId: "BS196123",
          salesCode: "20000660",
          partnerReferenceId: "",
          agentId: "",
          channel: "web-acm",
          siteId: headers?.siteId?.toLowerCase(),
        },
        planDetailRequest: {
          accountNumber: billingAccountNumber,
          addressId: serviceAddrId,
          flow : "change", // Added to trigger email on submit order
          isMigrated: reduxStore?.user?.data?.migratedAccount && reduxStore?.user?.data?.migratedAccount?.toUpperCase() === "Y" ? "Y" : "N"
        },
      };

      // if (
      //   headers?.siteId?.toLowerCase() === "ctl" ||
      //   "century link" ||
      //   "qf" ||
      //   "quantum fiber"
      // ) {
      const url=API_URLS["planDetails_QA_Url"];
        const params = {
          "": [url],
        };
        const response = await ctlFetchPlanDetails(params, headers, payload);
      //   if(response?.data?.standardPlans?.length === 0) {
      //     DwLogutil({
      //       stepName: EC_DW_LOGGING_STEPS.subscription_plan_failed, 
      //       error: "Response data is empty"
      //     })
      //   } else {
      //     DwLogutil({stepName: EC_DW_LOGGING_STEPS.subscription_plan_success})
      //   }
      //   let data=fixWIFICountWithGrandfather(response?.data,reduxStore?.user)
      //   return data;
      // } else {
      //   const response = await fetchPlanDetails(params, headers);
        if(response?.data?.standardPlans?.length === 0) {
          DwLogutil({
            stepName: EC_DW_LOGGING_STEPS.subscription_plan_failed,
            error: "Response data is empty"
          })
        } else {
          DwLogutil({stepName: EC_DW_LOGGING_STEPS.subscription_plan_success})
          if (response?.data?.jeopardyFlag === "Y" && reduxStore?.user?.data?.billingType?.toUpperCase() === "POSTPAID") {
            store.dispatch(setIsUserOnJeopardy(true));
          }
          else {
            store.dispatch(setIsUserOnJeopardy(false)); // Reset jeopardy status if not in jeopardy
          }
        }
        let data=fixWIFICountWithGrandfather(response?.data,reduxStore?.user)
        return data;
      // }
    } catch (error) {
      let errorMessage = (error as { message?: string})?.message ||  "somthing went wrong while fetching the API details"
 
      DwLogutil({
        stepName: EC_DW_LOGGING_STEPS.subscription_plan_failed,
        error: errorMessage
      })
      throw error;
    }
  }
);

export const getCTLPlanDetails = createAsyncThunk(
  "ctl-plan/details",
  async (user: any) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const serviceAddrId = getServiceAddressId(user?.addresses);
      // New Headers added on 2026-01-07
      if(headers?.nonAuthFlowType === "NON_AUTH_QBP"){
        return;
      }
      let url=API_URLS['managePlandetailsCTL']
      const dataResult = await getPlanDetailsCTL(
        {
          "": `${url}`,
        },
        {
          baseline: {
            transactionId: uuidv4().slice(0, 21),
            partnerId: "BS196123",
            salesCode: "20000660",
            partnerReferenceId: "",
            agentId: "",
            channel: "web-acm",
            siteId: headers?.siteId?.toLowerCase(),
          },
          productDetailRequest: {
            ban: user?.billingAccountNumber,
            addressId: serviceAddrId,
            isMigrated: user?.migratedAccount && user?.migratedAccount?.toUpperCase() === "Y" ? "Y" : "N"
          },
        },
        headers
      );
      if(!dataResult?.data?.internet?.amount) {
        DwLogutil({
          stepName: EC_DW_LOGGING_STEPS.subscription_acm_failed,
          error: "Response data is empty"
        })
      } else {
        DwLogutil({stepName: EC_DW_LOGGING_STEPS.subscription_acm_success})
      }
      return dataResult?.data || dataResult;
    } catch (error) {
      DwLogutil({
        stepName: EC_DW_LOGGING_STEPS.subscription_acm_failed,
        error: "somthing went wrong while fetching the API details"
      })
      throw error;
    }
  }
);

const planDetailSlice = createSlice({
  name: "plan/Details",
  initialState,
  reducers: {
    clearPlanDetailSlice: (state) => {
      return initialState;
    },
    setChangePlanUrl: (state, action: PayloadAction<string>) => {
      state.changePlanUrl = action.payload;
    },
    setIschangeFlow:(state, action: PayloadAction<boolean>) => {
      state.isChangeFlow = action.payload;
    },
    setNetworkType: (state, action: PayloadAction<string>) => {
      state.networkType = action.payload;
    },
    setPaperLessBilling: (state, action: PayloadAction<boolean>) => {
      state.paperLessBilling = action.payload;
    },
    setAutoPayEnrolled: (state, action: PayloadAction<boolean>) => {
      state.isAutoPayEnrolled = action.payload;
    },
    planDetailSliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getPlanDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPlanDetails.fulfilled, (state, action) => {
      state.planDetails = action.payload;
      state.paperLessBilling =
        action?.payload?.paperlessBilling === "ZY" ? true : false;
      state.isAutoPayEnrolled =
        action?.payload?.autoPayIndicator === "ZY" ? true : false;
      state.loading = false;
      state.error = null;
      state.retryCount = 0;  // Reset retry count on success
      state.fetched = true;  // Mark as fetched on success
    });
    builder.addCase(getPlanDetails.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "plan details",
        action.error?.message,
        action?.type
      );
      state.planDetails = null;
      state.loading = false;
      state.error = action.error;
      state.retryCount += 1;  // Increment retry count on failure
      DwLogutil({stepName: `subscription-plan API failed ${state.retryCount} time(s)`, error: `${action.error?.message}`});
      if (state.retryCount >= 2) {
        state.fetched = true;  // Block further retries after 2 failures
      }
    });
    builder.addCase(getCTLPlanDetails.pending, (state) => {
      state.ctlLoading = true;
    });
    builder.addCase(getCTLPlanDetails.fulfilled, (state, action) => {
      state.ctlPlanDetails = action.payload;
      //state.paperLessBilling  = (action?.payload?.paperlessBilling==="ZY")? true : false;
      // state.isAutoPayEnrolled = (action?.payload?.autoPayIndicator==="ZY")? true : false;
      state.ctlLoading = false;
      state.ctlError = null;
      state.ctlRetryCount = 0;  // Reset retry count on success
      state.ctlFetched = true;  // Mark as fetched on success
    });
    builder.addCase(getCTLPlanDetails.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "plan details",
        action.error?.message,
        action?.type
      );
      state.ctlPlanDetails = null;
      state.ctlLoading = false;
      state.ctlError = action.error;
      state.ctlRetryCount += 1;  // Increment retry count on failure
      DwLogutil({stepName: `subscription-acm API failed ${state.ctlRetryCount} time(s)`, error: `${action.error?.message}`});
      if (state.ctlRetryCount >= 2) {
        state.ctlFetched = true;  // Block further retries after 2 failures
      }
    });
  },
});

export const {
  clearPlanDetailSlice,
  setChangePlanUrl,
  setNetworkType,
  setAutoPayEnrolled,
  planDetailSliceSetInitialState,
  setIschangeFlow
} = planDetailSlice.actions;
export default planDetailSlice.reducer;
